import { defineAsyncActions } from '../utils/define-action';
import API from '../utils/api';
import queue from '../utils/queue';

const api = new API();

const CREATE_CART = defineAsyncActions('CREATE_CART');
const UPDATE_CART = defineAsyncActions('UPDATE_CART');
const SET_CART_REFUNDABLE = defineAsyncActions('SET_CART_REFUNDABLE');
const ADD_CART_PARTICIPANT = defineAsyncActions('ADD_CART_PARTICIPANT');
const UPDATE_CART_PARTICIPANT = defineAsyncActions('UPDATE_CART_PARTICIPANT');
const ADD_PRODUCT_TO_CART = defineAsyncActions('ADD_PRODUCT_TO_CART');
const REMOVE_PRODUCT_FROM_CART = defineAsyncActions('REMOVE_PRODUCT_FROM_CART');
const REPLACE_PRODUCT_IN_CART = defineAsyncActions('REPLACE_PRODUCT_IN_CART');

const initialState = {
  cart: null,
  participantId: null,
};

var isodate = new Date().toISOString()
window.newcart = {
  "products": [],
  "cart": {
      "address": null,
      "id": 8113,
      "created": isodate,
      "updated": isodate,
      "first_name": null,
      "last_name": null,
      "email": null,
      "contact_number": null,
      "status": 1,
      "push_status": 0,
      "dob": null,
      "price_total": 0,
      "representative_id": null,
      "representative_email": null,
      "representative_data": null,
      "analytic_data": null,
      "newsletter_signup": null,
      "locked": null,
      "test_transaction": null,
      "tracking_code": null,
      "transactions": [],
      "participants": [],
      "quantity": 0,
      "coupon_code": null,
      "coupon_data": null,
      "shipping_data": null,
      "taxation_data": null,
      "order_trace": null,
      "total_discount": 0
  }
};

export const createCart = () => {
  return async (dispatch) => {
    dispatch({ type: CREATE_CART.PENDING });

    //const res = await api.createCart();

    const res = window.newcart;

    console.log('createCart:', res);

    if (res) {
      dispatch({ type: CREATE_CART.FULFILLED, payload: res });
      return res;
    } else {
      dispatch({ type: CREATE_CART.REJECTED });
    }
  };
};

export const addCartParticipant = (cartId, params) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CART_PARTICIPANT.PENDING });

    //const res = await api.addParticipant(cartId, params);

    var isodate = new Date().toISOString()
    const participant = [{
        "id": 0,
        "created": isodate,
        "updated": isodate,
        "first_name": null,
        "last_name": null,
        "email": params.email,
        "phone": null,
        "medical_waiver": null,
        "preferred_shirt_size": null,
        "preferred_short_size": null,
        "dob": null,
        "gender": params.gender,
        "position": null,
        "price_total": 0,
        "age": params.age,
        "products": [],
        "quantity": 0
    }];
    window.newcart.participant_id = 0;
    window.newcart.cart.participants = participant;

    const res = window.newcart;

    console.log('addParticipant:', res);

    if (res) {
      dispatch({ type: ADD_CART_PARTICIPANT.FULFILLED, payload: res });
      return res;
    } else {
      dispatch({ type: ADD_CART_PARTICIPANT.REJECTED });
    }
  };
};

export const createCartWithParticipant = (params) => {
  return async (dispatch) => {
    const res = await dispatch(createCart());

    return dispatch(addCartParticipant(res.cart.id, params));
  };
};

export const updateCart = (params) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_CART.PENDING });

    // @TODO without push staus and status it returns 500, these are required params along with PUT
    const res = await api.updateCart(getState().cart.cart.id, {
      push_status: 0,
      status: 1,
      ...params,
    });
    if (res) {
      dispatch({ type: UPDATE_CART.FULFILLED, payload: res.cart });
      return res;
    } else {
      dispatch({ type: UPDATE_CART.REJECTED });
    }
  };
};

export const updateCartParticipant = (params) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_CART_PARTICIPANT.PENDING });

    const res = await api.updateCartParticipant(
      getState().cart.cart.id,
      getState().cart.participantId,
      params
    );
    if (res) {
      dispatch({ type: UPDATE_CART_PARTICIPANT.FULFILLED, payload: res.cart });
      return res;
    } else {
      dispatch({ type: UPDATE_CART_PARTICIPANT.REJECTED });
    }
  };
};

export const addProductToCart = (item) => {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_PRODUCT_TO_CART.PENDING, item });

    console.log('try refundable0', window.refundable);

    const res = await queue.enqueue(() =>
      api.addProductToCart(
        getState().cart.cart.id,
        getState().cart.participantId,
        {
          ...item,
          //refundable: getState().form.forcedRefundable,
          refundable: window.refundable,
        }
      )
    );

    if (res) {
      dispatch({
        type: ADD_PRODUCT_TO_CART.FULFILLED,
        payload: res,
      });
      const res_refundable = await dispatch(setCartRefundable(window.refundable));
      console.log('try refundable1', res_refundable);
      return res;
    } else {
      dispatch({ type: ADD_PRODUCT_TO_CART.REJECTED });
    }
  };
};

export const removeProductFromCart = (id) => {
  return async (dispatch, getState) => {
    dispatch({ type: REMOVE_PRODUCT_FROM_CART.PENDING, id });

    // Get product id
    /*
    console.log('GET STATE');
    console.log(getState().cart);
    var delete_product_id = 0;
    const cart_products_list = getState().cart.cart.participants;
    cart_products_list.forEach(item => {
      //console.log('Foreach item:', item);
      if(item.id === getState().cart.participantId){
        const cart_item_products = item.products;
        cart_item_products.forEach(product => {
          console.log('Foreach product:', product);
          if(product.id === id){
            delete_product_id = product.product.id;
          }
        });
      }
    });
    console.log('delete_product_id:', delete_product_id);
    */

    const res = await queue.enqueue(() =>
      api.removeProductFromCart(
        getState().cart.cart.id,
        getState().cart.participantId,
        id,
        /*delete_product_id*/
      )
    );

    if (res) {
      dispatch({ type: REMOVE_PRODUCT_FROM_CART.FULFILLED, payload: res });
      return res;
    } else {
      dispatch({ type: REMOVE_PRODUCT_FROM_CART.REJECTED });
    }
  };
};

export const replaceProductInCart = (item, id) => {
  return async (dispatch, getState) => {
    dispatch({ type: REPLACE_PRODUCT_IN_CART.PENDING, item, id });

    var cartbefore = window.newcart;
    console.log('replaceProductInCart remove/add', id, item.product.id);

    await queue.enqueue(() =>
      api.removeProductFromCart(
        getState().cart.cart.id,
        getState().cart.participantId,
        id
      )
    );

    const res = await queue.enqueue(() =>
      api.addProductToCart(
        getState().cart.cart.id,
        getState().cart.participantId,
        item
      )
    );

    console.log('replaceProductInCart before/after', cartbefore, window.newcart);

    if (res) {
      dispatch({ type: REPLACE_PRODUCT_IN_CART.FULFILLED, payload: res });
      return res;
    } else {
      dispatch({ type: REPLACE_PRODUCT_IN_CART.REJECTED });
    }
  };
};

export const setCartRefundable = (value) => {
  return async (dispatch, getState) => {
    dispatch({ type: SET_CART_REFUNDABLE.PENDING });

    console.log('setCartRefundable:', value);

    //const res = await api.updateCartRefundable(getState().cart.cart.id, value);

    const products = window.newcart.cart.participants[0].products;
    var price_total = 0;
    products.forEach(item => {
      if(value){

        if(value === 'Flexible' && item.product.price_flexible){
          price_total = price_total + (item.product.price_flexible * item.quantity);
        } else if (value === 'Refundable' && item.product.price_refundable){
          price_total = price_total + (item.product.price_refundable * item.quantity);
        } else {
          price_total = price_total + (item.product.price * item.quantity);
        }
        /*
        if(item.product.price_refundable){
          price_total = price_total + (item.product.price_refundable * item.quantity);
        } else {
          price_total = price_total + (item.product.price * item.quantity);
        }
        */
      } else {
        price_total = price_total + (item.product.price * item.quantity);
      }
    });
    window.newcart.cart.price_total = price_total;
    window.newcart.cart.refundable = value;

    const res = window.newcart;

    console.log('setCartRefundable1:', res);

    if (res) {
      dispatch({ type: SET_CART_REFUNDABLE.FULFILLED, payload: res.cart });
      return res;
    } else {
      dispatch({ type: SET_CART_REFUNDABLE.REJECTED });
    }
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CART.FULFILLED:
    case UPDATE_CART.FULFILLED:
    case UPDATE_CART_PARTICIPANT.FULFILLED:
    case SET_CART_REFUNDABLE.FULFILLED:
      return {
        ...state,
        cart: action.payload,
      };

    case ADD_CART_PARTICIPANT.FULFILLED:
      return {
        ...state,
        cart: action.payload.cart,
        participantId: action.payload.participant_id,
      };

    case ADD_PRODUCT_TO_CART.FULFILLED:
    case REMOVE_PRODUCT_FROM_CART.FULFILLED:
    case REPLACE_PRODUCT_IN_CART.FULFILLED:
      return {
        ...state,
        cart: action.payload.cart,
      };

    default:
      return state;
  }
};
